import { Component, OnDestroy, OnInit, ViewChild, ViewContainerRef, ChangeDetectorRef, ElementRef, ComponentFactoryResolver, ComponentRef } from '@angular/core';
import { SubSink } from 'subsink';
import { BsAppLaunchFormService } from '../../services/bs-app-launch-form.service';
import { FieldSetFormControl } from './field-set.control';
import { LaunchFieldHelpTextComponent } from '../../launch-field-help-text/launch-field-help-text.component';
import { ShadowDomConfig } from '@app/core/directives/shadow-dom.directive';

@Component({
  selector: 'app-bs-app-launch-field-set-control',
  templateUrl: './bs-app-launch-field-set-control.component.html',
  styleUrls: ['./bs-app-launch-field-set-control.component.scss']
})
export class BsAppLaunchFieldSetControlComponent implements OnInit, OnDestroy {
  @ViewChild('formContainer', { read: ViewContainerRef, static: false }) formContainer: ViewContainerRef;
  @ViewChild('accordion', { read: ElementRef, static: false }) accordion: ElementRef;
  
  formControl: FieldSetFormControl;
  shadowDomConfig: ShadowDomConfig;
  
  private subs = new SubSink();
  private helpTextComponentRef: ComponentRef<LaunchFieldHelpTextComponent>;

  constructor(
    private bsAppLaunchFormService: BsAppLaunchFormService,
    private resolver: ComponentFactoryResolver,
    private viewContainerRef: ViewContainerRef
  ) { }

  ngOnInit() {}

  ngAfterViewInit() {
    this.bsAppLaunchFormService.initializeForm(this.formControl.fields, this.formContainer, this.formControl);
    
    // If there's help text, create and inject the component into the accordion header
    if (this.formControl.helpText) {
      this.createAndInjectHelpTextComponent();
    }
  }

  private createAndInjectHelpTextComponent(): void {
    // Create the help text component dynamically
    const factory = this.resolver.resolveComponentFactory(LaunchFieldHelpTextComponent);
    this.helpTextComponentRef = this.viewContainerRef.createComponent(factory);
    
    // Set the input
    this.helpTextComponentRef.instance.helpText = this.formControl.helpText;
    
    // Trigger change detection to render the component
    this.helpTextComponentRef.changeDetectorRef.detectChanges();
    
    // Get the native element
    const helpTextElement = this.helpTextComponentRef.location.nativeElement as HTMLElement;
    
    // Add spacing for the accordion context
    helpTextElement.style.marginLeft = '4px';
    
    // Configure the shadow DOM directive to inject the element
    this.shadowDomConfig = {
      action: 'add',
      selector: '.rad-accordion__header-text',
      element: helpTextElement,
      position: 'append'
    };
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    
    // Clean up the dynamically created component
    if (this.helpTextComponentRef) {
      this.helpTextComponentRef.destroy();
    }
  }

}
